import { PSL_RULES } from "./pslData.js";
/**
 * Public Suffix List lookup (https://publicsuffix.org/list/), ICANN and private sections. Hosts
 * must be ASCII (punycode) and lowercase, as the URL parser hands them out.
 */
export class SuffixList {
    exact = new Set();
    /** `*.foo` is stored as `foo`. */
    wildcard = new Set();
    /** `!bar.foo` is stored as `bar.foo`. */
    exception = new Set();
    constructor(rules) {
        for (const line of rules.split("\n")) {
            const rule = line.trim();
            if (rule === "" || rule.startsWith("#") || rule.startsWith("//")) {
                continue;
            }
            if (rule.startsWith("!")) {
                this.exception.add(rule.slice(1));
            }
            else if (rule.startsWith("*.")) {
                this.wildcard.add(rule.slice(2));
            }
            else {
                this.exact.add(rule);
            }
        }
    }
    /**
     * The public suffix of `host`: the longest matching rule, exceptions first, and the implicit
     * `*` rule (the last label) when nothing matches. Undefined for an empty or malformed host.
     */
    publicSuffix(host) {
        const labels = normalize(host);
        if (labels === undefined) {
            return undefined;
        }
        for (let i = 0; i < labels.length; i += 1) {
            const candidate = labels.slice(i).join(".");
            if (this.exception.has(candidate)) {
                return labels.slice(i + 1).join(".");
            }
            if (this.exact.has(candidate) || (i + 1 < labels.length && this.wildcard.has(labels.slice(i + 1).join(".")))) {
                return candidate;
            }
        }
        return labels[labels.length - 1];
    }
    /** The public suffix plus one label (eTLD+1); undefined when the host is itself a public suffix. */
    registrableDomain(host) {
        const labels = normalize(host);
        const suffix = this.publicSuffix(host);
        if (labels === undefined || suffix === undefined) {
            return undefined;
        }
        const suffixLabels = suffix.split(".").length;
        return labels.length > suffixLabels ? labels.slice(labels.length - suffixLabels - 1).join(".") : undefined;
    }
    isPublicSuffix(host) {
        return this.registrableDomain(host) === undefined;
    }
}
/** Labels of a host without the trailing dot of a fully qualified name; undefined if any label is empty. */
function normalize(host) {
    const name = host.toLowerCase().replace(/\.$/u, "");
    const labels = name.split(".");
    return name === "" || labels.some((l) => l === "") ? undefined : labels;
}
let bundled;
/** The bundled list, parsed on first use. */
export function suffixList() {
    bundled ??= new SuffixList(PSL_RULES);
    return bundled;
}
export function publicSuffix(host) {
    return suffixList().publicSuffix(host);
}
export function registrableDomain(host) {
    return suffixList().registrableDomain(host);
}
export function isPublicSuffix(host) {
    return suffixList().isPublicSuffix(host);
}
//# sourceMappingURL=psl.js.map